
<!--<script src="../../../../packages/index.js"></script>-->
<template>

  <div style="height: 100%; overflow-y: auto">
    <dataTables v-if="tableVisible" ref="mainTable" :tableInfo="conf.mainTable" @mainTableReload="mainTableReload"
      @batchAudit="batchAudit" @exportStatisticTable="exportStatisticTable"
      @exportApplicationTable="exportApplicationTable">
    </dataTables>
    <el-dialog :visible.sync="submitAgainVisible" :modal-append-to-body="false">

      <div>
        {{infoFromStartWorkflow}}
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取消提交</el-button>
        <el-button type="primary" @click="handleSubmitAgain()">确认提交</el-button>
      </span>
    </el-dialog>

    <!--<el-dialog :visible.sync="confirmVisible" :modal-append-to-body="false">

            <avue-form
                    ref="avueform"
                    class="preview-form"
                    :option="options"
                    v-model="modeldata">

            </avue-form>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose()" >取消</el-button>
                    <el-button type="primary" @click="handleSubmit()">确认</el-button>
                </span>
        </el-dialog>-->

    <confirm-dialog :config-info="confirmInfo" @handleSubmit="handleSubmit">
    </confirm-dialog>

  </div>
</template>

<script>
import dataTables from '../InternalComponent/easyCrud.vue'
import conf from './conf'
import { doValidBeforeAudit, batchAuditFunc } from "../util/auditUtil";
import confirmDialog from '../InternalComponent/confirmDialog'



export default {
  data() {
    return {
      /*addVisible: false,*/
      formvisible: false,
      tableVisible: true,
      full: true,
      modeldata: {},
      options: {

      },
      conf,
      row: {},
      taskData: {},
      submitAgainVisible: false,
      infoFromStartWorkflow: '',
      postParams: {},
      isClassAudit: false,
      confirmInfo: {
        confirmVisible: false,
        options: {},
        modeldata: {}
      },

    }
  },

  components: { dataTables, confirmDialog },

  mounted: function (params) {
    this.$nextTick(() => {
      this.mainTableReload(this.$refs.mainTable.getReloadConditions())
    })
  },
  // updated() {
  //     if(this.options.column.length > 0){
  //
  //         changeConfigToForm(document.getElementsByTagName('label'), this.options)
  //
  //
  // }},



  methods: {
    handleSubmitAgain() {
      this.submitAgainVisible = false
      this.postParams.dataMap.verifyFlag = "2"
      this.$http.post('/wf-scholarship/batch-audit', this.postParams).then(response => {
        if (response.code === 200) {
          this.$message.info('成功执行')
          this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        } else {
          this.$message.error(response.code + response.msg)
        }
      }).catch(error => {
        if (error.msg)
          this.$message.error(error.msg)
        else
          this.$message.error(error.message)
      })
    },
    handleClose() {
      this.submitAgainVisible = false
    },

    batchAudit() {
      let selectedRows = this.$refs.mainTable.getSelectedRows();
      // 判断是否能批量审核
      if (!batchAuditFunc(this.conf, selectedRows, this.$message))
        return
      /*if(this.conf.mainTable.table.paging.total === 0){
          this.$message.info('当前无需要审批的流程')
          return
      }

      if(selectedRows.length === 0){
          this.$message.info('请先选择记录')
          return
      }else if(selectedRows.length > 1){
          let firstRow = selectedRows[0]
          for(let i = 1; i < selectedRows.length; i++){
              if(firstRow.awardPrizeName !== selectedRows[i].awardPrizeName){
                  this.$message.info("请选择相同名称的参评记录")
                  return
              }

          }
      }
      //this.doTimeAudit()//时间校验

      console.log(selectedRows)*/
      /*this.batchAuditFormDialog.dialogVisible = true
      if(this.batchAuditFormDialog.selectedValue){
          console.log(this.batchAuditFormDialog.selectedValue)
      }*/
      this.doAudit(selectedRows)
    },
    doAudit(rows) {
      console.log('rows')
      console.log(rows)
      let postParams = {
        businessTaskList: [],
        dataMap: {},
        taskDefKey: ""
      }
      if (this.$route.query.generalId && this.$route.query.generalId.length > 0) {
        postParams.taskDefKey = "XGCSH"
        for (let i = 0; i < rows.length; i++) {
          postParams.businessTaskList.push(
            {
              awardPrizeId: rows[i].awardPrizeId,
              awardYear: rows[i].awardYear,
              classId: rows[i].classId
              //  collegeId: this.$route.query.generalId,
            }
          )
        }
      } else {
        postParams.taskDefKey = "XYSH"
        for (let i = 0; i < rows.length; i++) {
          postParams.businessTaskList.push(
            {
              awardPrizeId: rows[i].awardPrizeId,
              awardYear: rows[i].awardYear,
              classId: rows[i].classId
            }
          )
        }
      }
      this.postParams = postParams
      doValidBeforeAudit(this.$http, '/wf-scholarship/batch-valid', postParams, this.confirmInfo, this.$message)

    },
    exportStatisticTable() {
      if (!this.conf.mainTable.table.reloadConditions['awardPrizeName']) {
        this.$message.info('请先在查询下拉框参评名称选择需要导出的参评名称')
        return
      }
      this.$message.info('开发中')
    },
    exportApplicationTable() {

      if (!this.conf.mainTable.table.reloadConditions['awardPrizeName']) {
        this.$message.info('请先在查询下拉框参评名称选择需要导出的参评名称')
        return
      }
      this.$message.info('开发中')
    },
    handleSubmit(formData) {
      console.log(this.confirmInfo.modeldata)

      for (let key in this.confirmInfo.modeldata) {
        this.postParams.dataMap[key] = this.confirmInfo.modeldata[key] + ""
      }
      console.log(this.postParams)
      this.postParams.dataMap.verifyFlag = "1"
      Object.assign(this.postParams.dataMap, formData)
      this.confirmInfo.confirmVisible = false
      this.$http.post('/wf-scholarship/batch-audit', this.postParams).then(response => {
        if (response.code === 200) {
          this.$message.info('成功执行')
        } else {
          this.$message.error(response.msg)
        }
      }).catch(err => {
        if (err.code === 1101) {
          this.submitAgainVisible = true
          this.infoFromStartWorkflow = err.msg
        } else {
          if (err.msg)
            this.$message.error(err.msg)
          else
            this.$message.error(err.message)
        }
      })


    },
    /** 当主表需要重载的时候 */
    mainTableReload: function (params) {
      console.log('route')
      console.log(this.$route)
      console.log(params)
      this.conf.mainTable.table.loading = true
      let JSONCon = {

      }
      if (this.$route.query.generalId && this.$route.query.generalId.length > 0) {
        JSONCon.collegeId = this.$route.query.generalId.split("=")[1]
        for (let i = 0; i < this.conf.mainTable.table.columns.length; i++) {
          if (this.conf.mainTable.table.columns[i].prop === 'collegeId') {
            this.conf.mainTable.table.columns[i].isSearchCondition = true
            break
          }
        }
      } else {
        JSONCon.classId = params.class_
        for (let i = 0; i < this.conf.mainTable.table.columns.length; i++) {
          if (this.conf.mainTable.table.columns[i].prop === 'collegeId') {
            this.conf.mainTable.table.columns[i].isSearchCondition = false
            break
          }
        }
      }
      this.$http.post('/wf-scholarship/group-by-class-id?pageNum=' + params.pageNum + '&pageSize=' + params.pageSize, JSONCon).then(
        response => {
          this.conf.mainTable.table.loading = false
          if (response.code === 200) {
            console.log(response.data)
            // 成功之后的数据
            if (response.data.records && response.data.records.length && response.data.records.length > 0) {
              for (let i = 0; i < response.data.records.length; i++) {
                response.data.records[i].urlPath = "/workflow/scholarship/BJSH"

                response.data.records[i].urlRow = "classId=" + response.data.records[i].classId


                response.data.records[i].urlName = response.data.records[i].class_

              }
            }


            if (!response.data.records)
              this.conf.mainTable.table.tableData = []
            else
              this.conf.mainTable.table.tableData = response.data.records
            this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          this.conf.mainTable.table.loading = false
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
          this.$Log.capsule('分页加载模板错误', error, 'danger')
        }
      )

    },
    /*deleteRows: function(row){//删除操作
        var params = new URLSearchParams()
        params.append("formId", row[0].id)
        this.$http.post('/formModel/delete?formId='+row[0].id).then(res => {
            //this.conf.mainTable.loading = false
            if(res.code === 200){
                this.$message.success('删除表单成功！')
                this.mainTableReload(this.$refs.mainTable.getReloadConditions())
            } else {
                this.$message.error(res.code + res.msg)
            }
        }).catch(error => {
            this.$message.error("error" + error)
        })
    },
    saveRowByAddOrEdit: function (row, done, errorDone, optionType) {
        console.log(optionType)
    },
    beforeAddViewEdit: function name(row, optionType, call) {
        var op
        if(optionType === 'EDIT') {//编辑操作
            this.$http.get('/detail', {params: {formId: row.id}}).then(response => {
                if(response.code === 200){
                    this.options = response.data.modelJson
                    this.tableVisible = false
                    this.addVisible = true
                } else {
                    this.$message.error(response.code + response.msg)
                }

            }).catch(error => {
                this.$message.error("error" + error)
            })

        } else if (optionType === 'ADD'){//新增操作

            this.tableVisible = false
            this.addVisible = true
        } else {
            this.$http.get('http://192.168.17.28:8081/flowExt/todoTaskDescription', {params:{'businessKey': row.businessKey, 'taskId': row.taskId}}).then(response => {
                if(response.code === 200){
                    console.log("tototototdotototototototototototototot")
                    console.log(response)

                } else {
                    this.$message.error(response.code + response.msg)
                }
            }).catch(error => {
                this.$message.error("error" + error)
            })
        }

    }*/
  }
}
</script>
<style lang="scss" scoped>
:deep(.drawer-foot) {
  position: absolute;
  /*bottom: 0;
        left: 0;
        right: 0;*/
  margin-top: 20px;
  //display: flex;

  button {
    width: 50%;
  }
}

.drawer-top {
  position: relative;
  height: 60px;
  text-align: center;
}
.button-top {
  text-align: right;
  position: absolute;
  top: 65px;
  right: 23px;
  display: flex;
  z-index: 90;
}

:deep(.preview-form) {
  padding-top: 10px;
  overflow-y: auto;
}
:deep(.avue-crud) {
  padding-bottom: 18px;
}
</style>
